<template>
  <v-tooltip location="top">
    <template #activator="{ props }">
      <span class="beta-tag" v-bind="props">
        <v-icon
          icon="mdi-wrench"
          size="12"
          class="mr-1"
          style="margin: 0; padding: 0; line-height: 1; width: 12px; min-width: 12px"
        />
        {{ t('general.betaLabel') }}
      </span>
    </template>
    <span>{{ t('general.betaFeatureDisclaimer') }}</span>
  </v-tooltip>
</template>

<script>
import { useInternationalization } from '@/composables/use-internationalization';

export default {
  name: 'BetaTag',

  setup() {
    const { t } = useInternationalization();
    return { t };
  },
};
</script>

<style lang="scss" scoped>
@import '@style/base/_variables.scss';

.beta-tag {
  background-color: $assortment-primary-colour;
  color: $rtls-white;
  border-radius: 4px;
  padding: 4px 10px;
  margin: 0 4px;
  font-size: 1rem;
  line-height: 1;
  font-weight: 600;
  display: inline-block;
  vertical-align: middle;
}
</style>
